export default [
  {
    icon: 'favorite-anim',
    title: 'Banka a poisťovňa v jednom',
    text: 'Oproti konkurencii máš výhodu - klientovi vieš ponúknuť produkty oboch.',
  },
  {
    icon: 'hands-anim',
    title: 'Pre skúsených aj nováčikov',
    text: 'Či si ostrieľaný finančný profík alebo úplný nováčik, určite sa u nás nájdeš.',
  },
  {
    icon: 'family-anim',
    title: 'Rodinné zázemie',
    text: '48\xa0%\xa0partnerov s\xa0nami spolupracuje dlhšie ako 5\xa0rokov vďaka priateľskému prostrediu, ktoré si obľúbiš.',
  },
  {
    icon: 'clap-anim',
    title: 'Partner, nie zamestnanec',
    text: 'Sám si určuješ pravidlá hry a\xa0vyberáš si, koľko času chceš venovať práci a koľko sebe.',
  },
];
